import React from 'react';
import { commonStyles } from '../styles/commonStyles';

interface SectionHeaderProps {
  /** Phosphor icon component (rendered duotone in the secondary colour). */
  icon: React.ComponentType<any>;
  title: string;
}

// Shared card section header: a duotone icon in its rounded container + the section title. Replaces
// the hand-rolled sectionHeader / sectionIconContainer / title trio repeated on the product screens.
export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon: Icon, title }) => (
  <div style={commonStyles.sectionHeader}>
    <div style={commonStyles.sectionIconContainer}>
      <Icon size={28} weight="duotone" color="var(--secondary-color, #F51C17)" />
    </div>
    <h2 style={commonStyles.sectionTitle}>{title}</h2>
  </div>
);

export default SectionHeader;
